import { z } from 'zod';

import { mobilePhoneSchema } from 'features/onboarding/schemas/primitives';

export const representativeSchema = z.object({
  representativeName: z.string().min(1, 'required'),
  representativePhone: mobilePhoneSchema,
  representativePosition: z.string().min(1, 'required'),
});

export type RepresentativeInput = z.infer<typeof representativeSchema>;
